import React from "react";
import { Row, Col, Grid ,FormGroup,Form,FormControl ,ControlLabel,Checkbox} from 'react-bootstrap'
import Signwith from "../Signwith/Signwith";

class Login extends React.Component {
	
	render() {
             
		return (

<div>
          
        <div className="Login">
        <Grid>
        <div className="Login-bg">

            <Row>
                <Col md={6}>
                <div className="Login-left">
                <h3>Login</h3>
                <div className="Login-caption">

                <p> Get in, and discover Our outfits</p>
                </div>
                <Form horizontal>
  <FormGroup controlId="formHorizontalEmail">
  
      <FormControl type="email" placeholder="Username" />
  </FormGroup>
  <FormGroup controlId="formHorizontalEmail">
  
  <FormControl type="password" placeholder="Password" />
</FormGroup>
<Col>
      <Checkbox>Remember me</Checkbox>
      <a  className="Login-Forgit" href="#"> Lost Your Password </a>

    </Col>
    <button type="button" class="login_create btn btn-secondry">Login</button>
<div className="Login-hint">
<p> By login you agree to our <a href="#">terms & conditions  </a>of use </p>
</div>
  </Form>
  </div>

                </Col>
                <Col md={6}>
                <div className="Login-right">
                <h3> Register </h3>
                <div className="Login-caption">

              <p> Join Our Community</p>
              </div>
              <form class="form-horizontal">
                <img src={require("../../img/Home/logo.png")}/>
                <div className="Login-content">
                <p> Lorem ipsum dolor sit amet, conse
ctetur adipisicing elit, sed do eius
mod tempor incididunt ut labore et dolore magna aliqua. </p>
</div>
<a href="/Register"><button type="button" class="login_create btn btn-secondry">Create an account</button></a>
</form>
                </div>
               
                </Col>
                <div className="Login-hr clearfix">
                 <hr/>
                 </div>
                 <Signwith/>

             </Row>
</div>
        </Grid>

  </div>
       
        

      
        </div>

       );
    }
  }
  
  export default Login;
  


// WEBPACK FOOTER //
// ./src/Components/Login/Login.jsx